export const TEXT = 'text';
export const SIZE_S = '_S';
export const SIZE_M = '_M';
export const SIZE_L = '_L';
export const SIZE_XL = '_XL';
export const TEXT_SIZES = {
    S: SIZE_S,
    M: SIZE_M,
    L: SIZE_L,
    XL: SIZE_XL
};
